import { AxiosInstance } from 'axios';
import { NotificationResponse, PagedResponse } from '../interfaces/INotification';

export type NotificationScope = 'admin' | 'participant';

export class NotificationService {
    private readonly basePath: string;

    constructor(
        private apiClient: AxiosInstance,
        private readonly scope: NotificationScope,
    ) {
        this.basePath = this.scope === 'participant' ? '/participant/notifications' : '/notifications';
    }

    /**
     * Get paginated notifications for the current user
     */
    async getNotifications(
        page: number = 1,
        pageSize: number = 20,
        includeRead: boolean = true
    ): Promise<PagedResponse<NotificationResponse>> {
        const params = new URLSearchParams({
            page: page.toString(),
            pageSize: pageSize.toString(),
            includeRead: includeRead.toString(),
        });

        const response = await this.apiClient.get<PagedResponse<NotificationResponse>>(
            `${this.basePath}?${params}`
        );
        return response.data;
    }

    /**
     * Get unread notification count
     */
    async getUnreadCount(): Promise<number> {
        const response = await this.apiClient.get<number>(`${this.basePath}/unread-count`);
        return response.data;
    }

    /**
     * Mark a notification as read
     */
    async markAsRead(notificationId: string): Promise<void> {
        await this.apiClient.patch(`${this.basePath}/${notificationId}/read`, null);
    }

    /**
     * Mark all notifications as read
     */
    async markAllAsRead(): Promise<number> {
        const response = await this.apiClient.patch<number>(`${this.basePath}/mark-all-read`, null);
        return response.data;
    }
}
